import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFlagsmith, useFlagsmithLoading } from 'flagsmith/react';

/**
 * Sincroniza la identidad del usuario de Redux con Flagsmith.
 * Debe montarse dentro de Redux Provider y FlagsmithProvider.
 * Renderiza children sin alterar el árbol.
 */
export function FlagsmithIdentifyOnUser({ children }) {
  const user = useSelector((state) => state.initialData?.user);
  const brand = useSelector((state) => state.initialData?.brand);
  const flagsmith = useFlagsmith();

  useFlagsmithLoading(); // Trigger re-render cuando el SDK termina de inicializarse

  useEffect(() => {
    if (!flagsmith?.initialised) return;

    const flagsmithIdentityId = user?.username; // Identificador único de la identidad en Flagsmith. Es poco probable que cambie. Se lo utiliza porque facilita la identificación del usuario
    if (!flagsmithIdentityId) return;

    const traits = {
      user_id: user.id,
      full_name: user.fullName,
      profile_id: user.perfil,
      profile_name: user.profileName,
      brand_id: brand?.id,
      brand_softseguros_id: brand?.softseguros_id,
      brand_name: brand?.name,
    };

    // Elimina propiedades nulas
    const filteredTraits = Object.fromEntries(
      Object.entries(traits).filter(([_, value]) => value != null)
    );

    flagsmith.identify(flagsmithIdentityId, filteredTraits).catch((err) => {
      console.error('Error identifying user in Flagsmith:', err);
    });
  }, [
    flagsmith,
    user?.id,
    user?.username,
    user?.fullName,
    user?.perfil,
    user?.profileName,
    brand?.id,
    brand?.softseguros_id,
    brand?.name,
  ]);

  return children;
};